import {twMerge} from 'tailwind-merge';
import React, {FC, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger} from '../../../Components';
import {useDefineSettings} from '../../../hooks/useDefineSettings';
import {groupBy} from '../../../utils';

/** The settings menu below tablet: a bar naming the current section that opens the grouped list. */
export const SettingsDropdown: FC = () => {
  const settings = useDefineSettings();
  const location = useLocation();
  const [openValue, setOpenValue] = useState('');

  const current = settings.find((s) => location.pathname === s.to || location.pathname.startsWith(`${s.to}/`));
  const groups = groupBy(settings, 'group');

  return (
    <NavigationMenu
      className="w-full max-w-none flex-none border-b border-[#ebecf0] bg-[#fbfbfc] tablet:hidden"
      value={openValue}
      onValueChange={setOpenValue}
    >
      <NavigationMenuList className="w-full">
        <NavigationMenuItem className="flex-1" value="settings">
          <NavigationMenuTrigger className="w-full justify-between rounded-none bg-transparent px-4 text-[#33364b] hover:bg-black/5">
            {current?.label || 'Settings'}
          </NavigationMenuTrigger>
          <NavigationMenuContent className="max-h-[60vh] overflow-y-auto shadow-md">
            {Object.entries(groups).map(([group, items]) => (
              <div key={group} className="px-1 pb-2">
                <div className="px-3 pt-3 pb-1 text-[10px] font-medium uppercase tracking-wider text-[#9b9ea8]">{group}</div>
                {items.map((item) =>
                  item.disabled ? (
                    <div key={item.to} className="block w-full px-3 py-2.5 text-[14px] text-gray-300">
                      {item.label}
                    </div>
                  ) : (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={() => setOpenValue('')}
                      className={twMerge(
                        'block w-full rounded-md px-3 py-2.5 text-[14px] no-underline text-[#474b59] transition-colors hover:bg-gray-100',
                        item.to === current?.to && 'bg-[#efedfb] font-medium text-[#654dcb]',
                      )}
                    >
                      {item.label}
                    </Link>
                  ),
                )}
              </div>
            ))}
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};
